export default __webpack_public_path__ + "files/BC6.pdf";